import { useState, useEffect } from "react";

const useIsMobile = (breakpoint = 992) => {
    // Enhanced mobile detection function
    const detectMobileDevice = () => {
        if (typeof window === "undefined") return false;

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Check for mobile/tablet User Agents
        const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(userAgent.toLowerCase());

        // Special check for modern iPads (iPadOS 13+) which identify as Macintosh
        const isModernIPad = (
            (navigator.platform === 'MacIntel' || userAgent.includes('Macintosh')) &&
            navigator.maxTouchPoints > 0
        );

        // Check for touch capabilities
        const hasTouchScreen = (
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
        );

        // Check screen width
        const isSmallScreen = window.innerWidth < breakpoint;

        // Device is mobile if:
        // 1. Has mobile/tablet User Agent, OR
        // 2. Is a modern iPad (even if masquerading as desktop), OR
        // 3. Has touch screen AND small screen
        return isMobileUA || isModernIPad || (hasTouchScreen && isSmallScreen);
    };

    // Initialize with the correct value to avoid initial desktop render
    const [isMobile, setIsMobile] = useState(() => detectMobileDevice());

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(detectMobileDevice());
        };

        // Check on mount
        checkIsMobile();

        // Add listener
        window.addEventListener("resize", checkIsMobile);

        // Cleanup
        return () => window.removeEventListener("resize", checkIsMobile);
    }, [breakpoint]);

    return isMobile;
};

export default useIsMobile;
